import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthorisedSideNavService {
  hideSideNav: boolean = true;
  showSpinner: boolean = false;

  constructor() { }

  toggleSideNav(): void {
    this.hideSideNav = !this.hideSideNav;
  }


  startSpinner() {
    this.showSpinner = true;
  }

  stopSpinner() {
    this.showSpinner = false;
  }

}
